module.exports = "<!-- <app-navbar></app-navbar> -->\n<app-highlight></app-highlight>\n<app-panel [childPanelList]=\"masterPanelList\"></app-panel>\n"


//////////////////
// WEBPACK FOOTER
// /Users/skye/Projects/Epicodus Projects/JavaScript/mock-mint/src/app/homepage/homepage.component.html
// module id = ../../../../../src/app/homepage/homepage.component.html
// module chunks = main